export const OPTIONS_TRANSPORT = [
  {
    value: 0,
    label: '(CIF) Contratação pelo Remetente',
  },
  {
    value: 1,
    label: '(FOB) Contratação pelo Destinatário',
  },
  {
    value: 2,
    label: 'Contratação do Frete por conta de Terceiros',
  },
  {
    value: 3,
    label: 'Transporte Próprio por conta do Remetente',
  },
  {
    value: 4,
    label: 'Transporte Próprio por conta do Destinatário',
  },
  {
    value: 9,
    label: 'Sem frete',
  },
];
